import * as React from 'react';
import { useState } from 'react';

import { Eye, EyeOff } from 'lucide-react';

import { Input } from './input';

export interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(({ className, ...props }, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const togglePassword = () => setShowPassword((show) => !show);

  return (
    <div className="relative flex flex-row">
      <Input type={showPassword ? 'text' : 'password'} className={className} {...props} ref={ref} />
      <button type="button" onClick={togglePassword} className="absolute right-3 top-2.5 h-6 w-6 text-gray-400">
        {showPassword ? <EyeOff /> : <Eye />}
      </button>
    </div>
  );
});
PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
